import React, { useEffect, useState, useMemo } from "react";
import Head from "next/head";
import PageBanner from "../../components/Common/PageBanner";
import Navbar from "../../components/_App/Navbar1";
import Link from "next/link";
import Footer from "../../components/_App/Footer";
import * as fbq from "../../lib/fpixel";
import { useRouter } from "next/router";
import axios from "axios";
import orderAPI from "../../axios-setup/order-service";
import webAPI from "../../axios-setup/web-api";
import ReactGA from "react-ga";
import Pagination from "../../components/pagination";

import formatAmount from "indian-currency-formatter";

export default function CategoryDetails({ dataNav, slug, page1Products }) {
  const [tabUrl, setTabUrl] = useState(null);
  const [title, setTitle] = useState("");
  const [images, setImages] = useState(null);
  const [categoryName, setCategoryName] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalResults, setTotalResults] = useState(1);
  const [products, setProducts] = useState(page1Products);

  const getProductByCategory = async () => {
    const res = await webAPI.get(
      "/categories/" + slug + `/products?page=${currentPage}`
    );

    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }

    setProducts(res.data.products);
    setPageSize(res.data.pageCount);
    setTotalResults(res.data.products.count);
  };

  useEffect(() => {
    getProductByCategory();
  }, [currentPage, slug]);

  useEffect(() => {
    setTabUrl(window.location.href);
    setTitle(document.title);
    setImages(document.images[0].src);
    setCategoryName(
      products && products.rows.length && products.rows[0].category.name
    );
  }, []);

  React.useEffect(() => {
    setCurrentPage(1);

    const getCategory = async () => {
      const res = await webAPI.get(`/categories/${slug}`);
      const category = res.data;
      ReactGA.event({
        category: "category",
        action: "category_view",
        label: slug,
        nonInteraction: true,
      });
      fbq.event("ViewCategory", {
        content_type: "product",
        content_name: category.name,
        content_ids: category.id,
        content_category: category.name,
      });
    };
    getCategory();
  }, [slug]);

  //Log affiliate link
  const router = useRouter();

  const logCtr = async () => {
    const hash_key = router.query.referral_code;
    if (typeof window !== "undefined") {
      try {
        await orderAPI.post("/url/log", {
          hash_key,
          browser_id: localStorage.getItem("FPJS").replace(/"/g, ""),
          landing_url: window.location.href,
        });
      } catch (error) {
        console.log(error);
      }
    }
  };
  useEffect(() => {
    if (
      router.query.referral_code &&
      router.query.referral_code !== "" &&
      router.asPath
    )
      logCtr();
  }, [router]);
  return (
    <React.Fragment>
      <Navbar data={dataNav} />

      {products && products.count > 0 && products.rows[0] && (
        <PageBanner
          pageTitle={products && products.rows[0].category.name}
          homePageUrl="/"
          homePageText="Home"
          activePageText={products && products.rows[0].category.name}
        />
      )}

      <div>
        <Head>
          <link
            href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css"
            rel="stylesheet"
            integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC"
            crossorigin="anonymous"
          ></link>
          {/* <title>{title}</title> */}
          <meta
            name="viewport"
            content="initial-scale=1.0, width=device-width"
          />
          <meta property="og:title" content={title} />
          <meta
            name="description"
            content={`Save your most valuable Time, and Money with expert-curated content and personalized learning for ${categoryName}`}
          />
          <meta
            property="og:description"
            content={`Save your most valuable Time, and Money with expert-curated content and personalized learning for ${categoryName}`}
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={tabUrl} />
          <meta property="og:image" content={images} />
          <link
            rel="canonical"
            // property="og:title"
            // content={title}
            // key="title"
            href={tabUrl}
          ></link>
        </Head>
      </div>

      {products && products.count > 0 ? (
        <div className="courses-area courses-section pt-100 pb-70">
          <div className="container">
            <div className="edemy-grid-sorting row align-items-center">
              <div className="col-lg-8 col-md-6 result-count">
                {products && (
                  <p>
                    We found <span className="count">{products.count}</span>{" "}
                    courses available for you
                  </p>
                )}
              </div>

              {/* <div className="col-lg-3 col-md-6 ordering">
                <div className="select-box">
                  <select className="form-control">
                    <option>Sort By</option>
                    <option>Popularity</option>
                    <option>Latest</option>
                    <option>Price: low to high</option>
                    <option>Price: high to low</option>
                  </select>
                </div>
              </div> */}
            </div>

            <div className="row">
              {products &&
                products.rows &&
                products.rows.map((product) => (
                  <div className="w-1/2 md:w-1/4">
                    <a href={"/product/" + product.product.product_link}>
                      <div className="single-courses-box">
                        <div className="courses-image">
                          <Link
                            href={"/product/" + product.product.product_link}
                          >
                            <a className="d-block image">
                              <img
                                src={product && product.product.img1}
                                className="object-contain md:h-72 w-100"
                                alt="image"
                              />
                            </a>
                          </Link>
                          <a href="#" className="fav">
                            <i className="flaticon-heart"></i>
                          </a>
                          {/* <div className="price shadow">
                            Rs {product && product.product.offer_price}
                          </div> */}
                        </div>
                        <div className="courses-content p-2.5">
                          {/* <div className="course-author d-flex align-items-center">
                           <img src="/images/user4.jpg" className="rounded-circle" alt="image" />
                           <span>James Anderson</span>
                       </div> */}

                          <div className="text-sm mt-1 overflow-hidden">
                            <Link
                              href={"/product/" + product.product.product_link}
                            >
                              <a className="capitalize font-medium md:font-semibold">
                                {product && product.product.name}
                              </a>
                            </Link>
                          </div>

                          {/* <div className="max-h-10 mt-4 truncate" dangerouslySetInnerHTML={{ __html: unescapeHTML(product.product.description) }}></div> */}
                          <ul className="mt-4 flex gap-2 items-center">
                            {product && (
                              <li>
                                <span className="text-gray-400 line-through">
                                  ₹{formatAmount(product.product.price)}
                                </span>
                              </li>
                            )}
                            {product && (
                              <li>
                                <span className="text-gray-800 font-semibold">
                                  ₹{formatAmount(product.product.offer_price)}
                                </span>
                              </li>
                            )}
                            {/* {product && product.rating ? (
                              <span className="inline-flex rounded-full items-center my-2 pl-2.5 pr-1 text-sm font-medium bg-tn-green text-white">
                                {Math.round(product.rating * 10) / 10}
                                <button
                                  type="button"
                                  className="flex-shrink-0 ml-0.5 h-4 w-4 rounded-full inline-flex items-center justify-center "
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="h-5 w-5 text-white"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                  >
                                    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                                  </svg>
                                </button>
                              </span>
                            ) : null} */}
                          </ul>
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
            </div>
          </div>
        </div>
      ) : (
        "No Products In This category"
      )}
      <div className="inline-flex !flex !justify-center p-6">
        <Pagination
          className="pagination-bar"
          currentPage={currentPage}
          totalCount={totalResults}
          pageSize={12}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
      <Footer />
    </React.Fragment>
  );
}

export const getStaticPaths = async () => {
  const res = await webAPI.get("/categories/list");

  const categories = res.data;
  const paths = categories.map((category) => ({
    params: { slug: category.slug.toString() },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps = async (context) => {
  const slug = context.params.slug;
  const res = await webAPI.get("/categories/" + slug + `/products?page=1`);

  const products = res.data.products;
  return {
    props: { slug, page1Products: products },
  };
};
